<div class="flex flex-col items-center justify-center h-1/4">
  <mat-icon class="s-52 orange-fg">warning</mat-icon>
  <h2 i18n class="animate-pulse mt-4 mb-2 text-lg font-medium text-gray-800">Нет данных для отображения</h2>
</div>
